import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/Hero";
import Story from "../components/Story";
import Projects from "../components/Projects";
import Connect from "../components/Connect";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Story />
      <Projects />
      <Connect />
    </main>
  );
}
